import React, { useState } from 'react';
import '../App.css';
import HeroSection from '../components/HeroSection';
import { Helmet } from 'react-helmet-async';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    message: '',
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // Send data to your PHP script
      const response = await fetch('/send-email.php', {  // Adjust path if needed
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData).toString(),
      });

      const result = await response.text();

      if (response.ok) {
        setSubmitMessage('Thank you for your message! We will get back to you soon.');
        setFormData({
          name: '',
          email: '',
          phone: '',
          company: '',
          message: '',
        });
      } else {
        setSubmitMessage('Sorry, there was an error sending your message. Please try again.');
      }
    } catch (error) {
      setSubmitMessage('Network error. Please check your connection and try again.');
    } finally {
      setIsSubmitting(false);
      setTimeout(() => setSubmitMessage(''), 5000);
    }
  };

  return (
    <>
      <Helmet>
        <title>Contact Us – Blackswift Inventories | Malawi & South Africa Offices</title>
        <meta name="description" content="Get in touch with Blackswift Inventories. Offices in Lilongwe, Malawi and Midrand, South Africa. Let's discuss your brand's success." />
      </Helmet>
      <HeroSection 
        title="Get In Touch"
        subtitle="Contact us to learn how we can help your brand succeed in Southern African markets."
        buttonText="Send Message"
        buttonLink="#contact-form"
        backgroundImage="/contact-bg.jpg"
        showIllustration={false}
      />

      <section className="section">
        <div className="container">
          <div className="contact-grid">
            {/* Contact Form */}
            <div className="form-card" id="contact-form">
              <h2>Send Us a Message</h2>
              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-group">
                  <input
                    type="text"
                    name="name"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="form-input"
                  />
                </div>
                <div className="form-group">
                  <input
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="form-input"
                  />
                </div>
                <div className="form-group">
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Phone Number"
                    value={formData.phone}
                    onChange={handleChange}
                    className="form-input"
                  />
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    name="company"
                    placeholder="Company Name"
                    value={formData.company}
                    onChange={handleChange}
                    className="form-input"
                  />
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    placeholder="Your Message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="6"
                    className="form-textarea"
                  />
                </div>
                <button 
                  type="submit" 
                  className="btn submit-btn"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Sending...' : 'Send Message'}
                </button>
                {submitMessage && (
                  <p className="form-message">{submitMessage}</p>
                )}
              </form>
            </div>

            {/* Contact Information */}
            <div>
              <div className="info-card">
                <h2>Our Offices</h2>
                
                <div className="office-block">
                  <h3 className="office-title">Malawi Headquarters</h3>
                  <p className="office-address">
                    Blackswift Inventories Ltd<br />
                    John Chilembwe RD, Area 4<br />
                    Accord Centre Building,<br />
                    Block B, 188.<br />
                    Lilongwe,<br />
                    Malawi.
                  </p>                 
                </div>

                <div className="office-block">
                  <h3 className="office-title">South Africa Office</h3>
                  <p className="office-address">
                    Blackswift Inventories (Pty) Ltd<br />
                    137 9th Carlswald<br />
                    Midrand, 1685 South Africa
                  </p>                  
                </div>

                <div className="info-block">
                  <h3 className="info-title">Business Hours</h3>
                  <p className="hours-text">
                    Monday - Friday: 8:00 AM - 6:00 PM<br />
                    Saturday: 9:00 AM - 1:00 PM<br />
                    Sunday: Closed
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;